function decodeMinewQrCodeString (qrCodeString) {
  const formattedQrCodeString = formatAlternateIdKey(qrCodeString)

  if (formattedQrCodeString.length === 12 &&
    /^[a-zA-Z]{2}[0-9]{2}[a-zA-Z0-9]{8}/.test(formattedQrCodeString)) {
    return formattedQrCodeString
  }

  return ''
}

function decodeKkmQrCodeString (qrCodeString) {
  if (qrCodeString.length >= 12 && qrCodeString.length < 32 &&
    /^MAC:[a-zA-Z]{2}[0-9]{2}[a-zA-Z0-9]{8},SERIAL.+/.test(qrCodeString)) {
    return qrCodeString.split(':')[1].split(',')[0]
  }

  return ''
}

function decodeHoneyCommQrCodeString (qrCodeString) {
  const formattedQrCodeString = formatAlternateIdKey(qrCodeString)

  if (formattedQrCodeString.length === 12 &&
    /^[a-zA-Z]{1}[a-zA-Z0-9]+$/u.test(formattedQrCodeString)) {
    return formattedQrCodeString
  }

  return ''
}

function formatAlternateIdKey (address) {
  return address.replace(/:/ug, '').replace(/-/ug, '').toUpperCase()
}

function isBleAlternateIdKey (key) {
  return decodeHoneyCommQrCodeString(key) ||
    decodeMinewQrCodeString(key) ||
    decodeKkmQrCodeString(key)
}

module.exports = {
  decodeMinewQrCodeString,
  decodeKkmQrCodeString,
  decodeHoneyCommQrCodeString,
  formatAlternateIdKey,
  isBleAlternateIdKey
}
